import React from 'react';
import { Invitation } from '../../stores/reducers/invitations';
import Avatar from '../general-components/avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import Icon, { ICONS, COLORS } from '../general-components/icon';
import classNames from 'classnames';
import { GreenroomState } from '../../stores/types/types';
import { useSelector } from 'react-redux';
import useProfile from '../../hooks/use-profile';

interface InviteRequestProps {
	invite: Invitation;
	approve: (ev: Invitation) => void;
	block: (ev: Invitation) => void;
	small?: boolean;
}

export default function InviteRequest(props: InviteRequestProps) {
	const {
		invite: {
			profile
		},
		approve,
		block,
		small
	} = props;

	const useMasks = useSelector((s: GreenroomState) => s.SettingsReducer.featureFlags.use_profile_masks)
	const {watchedProfile} = useProfile({suggestedProfile: profile.gr_user});
	const shownProfile = (useMasks && watchedProfile) ? watchedProfile : profile;

	return (
		<div className={classNames("invite-request", { small: small })}>
			<Avatar
				user={shownProfile}
				size={small ? 'thirtytwo' : 'small'}
				noBorder={true}
			/>
			<label>{shownProfile.first_name} {shownProfile.last_name}</label>
			<div className="invite-actions">
				<button
					onClick={() => block(props.invite)}
					className="block">
					<Icon name={ICONS.CLOSE} color={COLORS.WHITE} size={15} />
				</button>
				<button
					onClick={() => approve(props.invite)}
					className="accept">
					<Icon name={ICONS.CHECK} size={15} color={COLORS.BLACK} />
				</button>

			</div>
		</div>
	)
}